import { IChatData } from '../interfaces/chat.interface';

export const SESSION_NAME = 'Centro de Ayuda';

export const initialChat: IChatData = {
    id: '1',
    from: 'Comfama',
    message: 'Hola 👋 ¿en qué te puedo ayudar?',
    vote: null,
};

export const formChat: IChatData = {
    id: String(Date.now()),
    from: 'form',
    message: 'Para continuar por favor ingresa los siguientes datos',
    vote: null,
};

export const chatInitialState = {
    showChat: false,
    chatData: [],
    chatDataMD: [],
    sessionData: String(Date.now()),
    sessionId: null,
};

/* eslint-disable no-unused-vars */
export enum voteValues {
    positive = 1,
    negative = 2,
}
/* eslint-disable no-unused-vars */
